import script from "./ExportPDF.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExportPDF.vue?vue&type=script&lang=ts&setup=true"

import "./ExportPDF.vue?vue&type=style&index=0&id=4b014fec&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b014fec"]])

export default __exports__